import {DocumentPart} from '@dv5/domain'

export const getPreviewPart = (part: DocumentPart, content: string): DocumentPart => ({
    ...part,
    partContent: content,
})